module.exports = __webpack_public_path__ + "img/dex_asesmen.16d192c1.svg";